import React from "react";
import TextField from "material-ui/TextField";
import colors from "../../styles/colors";

const style = {
  error: {
    color: colors.accent,
  },
  floatingLabelFocus: {
    color: colors.accent,
  },
};

export default ({ ...props, readOnly, whiteLabelSettings }) => {
  const lblStyle = {
    color:
      whiteLabelSettings && whiteLabelSettings.isWhiteLabel
        ? whiteLabelSettings.accentColor
        : colors.accent,
  };
  return (
    <TextField
      {...props}
      floatingLabelFocusStyle={lblStyle}
      errorStyle={lblStyle}
      disabled={readOnly}
      inputStyle={readOnly ? { color: colors.text } : null}
    />
  );
};



// WEBPACK FOOTER //
// ./src/components/common/NormalTextField.js